import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type { WebUserGetProfileExtraOutputDto } from '@bldsoft/ovp-api-types'
import type { API } from '@setplex/tria-api'
import { payload } from '../../../result'
import { formatUsersPreferences } from '../../onboarding/format'

export function use(client: OvpClient, users: API['users'], _api: API): void {
  // GET /api/web/users/extra
  users.getExtraFx.use(async () => {
    const data = payload<WebUserGetProfileExtraOutputDto>(
      await client.get.api.web.users.extra()
    )

    if (!data) {
      throw new Error('Empty answer in users.getExtraFx')
    }

    return formatUsersPreferences(data)
  })
}
